import { mirandaMediaArray } from './mirandaMedia'
import { mirandaBio } from './mirandaBios'

import { carrieReviewerReviewHinge, charlotteReviewerReviewBumble, samanthaReviewerReviewTinder } from './mirandaReviewerReviews'
import { carrieReviewerProfile, charlotteReviewerProfile, samanthaReviewerProfile } from './mirandaReviewers'

export const carrieProfileReviewHinge = {
  _id: 'carrieProfileReviewHingeId',
  userId: 'mirandaUserId',
  userEmail: 'miranda@email.com',
  datingProfileId: 'mirandaDatingProfileHingeId',
  reviewerProfileId: 'carrieReviewerProfileId',
  reviewerEmail: 'carrie@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: mirandaMediaArray[2]._id,
      mediaItemURL: mirandaMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[2].type,
      caption: mirandaMediaArray[2].captions[1],
      subcaption: mirandaMediaArray[2].subcaptions[1],
    },
    {
      mediaItemId: mirandaMediaArray[8]._id,
      mediaItemURL: mirandaMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[8].type,
      caption: mirandaMediaArray[8].captions[1],
      subcaption: mirandaMediaArray[8].subcaptions[1],
    },
    {
      mediaItemId: mirandaMediaArray[6]._id,
      mediaItemURL: mirandaMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[6].type,
      caption: mirandaMediaArray[6].captions[0],
      subcaption: mirandaMediaArray[6].subcaptions[2],
    },
    {
      mediaItemId: mirandaMediaArray[7]._id,
      mediaItemURL: mirandaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[7].type,
      caption: mirandaMediaArray[7].captions[0],
      subcaption: mirandaMediaArray[7].subcaptions[2],
    },
    {
      mediaItemId: mirandaMediaArray[13]._id,
      mediaItemURL: mirandaMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[13].type,
      caption: mirandaMediaArray[13].captions[0],
      subcaption: mirandaMediaArray[13].subcaptions[0],
    },
    {
      mediaItemId: mirandaMediaArray[12]._id,
      mediaItemURL: mirandaMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[12].type,
      caption: mirandaMediaArray[12].captions[1],
      subcaption: mirandaMediaArray[12].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great here! Love the dress, the earrings, and the candlelight! Great start!`,
      verdict: 'Very',
    },
    {
      feedback: `Another fabulous photo of you! You look fit be Napoleon's next wife`,
      verdict: 'Yes',
    },
    {
      feedback: `Love it! After the two fancier photos, you cut the tension with something more casual and fun. Love the expression`,
      verdict: 'Yes',
    },
    {
      feedback: `OK, I find it funny, but I'm not sure a guy wants to see the Miranda who yells at pigeons until at least the third date`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Hot by the transitive property for sure! Gotta show off the friends`,
      verdict: 'Yes',
    },
    {
      feedback: `Great photo! If you got it flaunt it!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: mirandaBio._id,
    vitalInfo: { ...mirandaBio.vitalInfo },
    prompts: [
      { ...mirandaBio.prompts[0] },
      { ...mirandaBio.prompts[1] },
      { ...mirandaBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Beautiful and successful — Sugar momma alert!`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `This is good — let them know you aren't impressed by money... They gotta learn you're a badass at somepoint`,
        verdict: 'Yes', 
      },
      {
        feedback: `Shows you as a specific brand of yuppy elite... that you definitely are`,
        verdict: 'Yes', 
      },
      {
        feedback: `This is funny! "Only if the carpet matches the drapes" is the odds-on favorite for likeliest response`,
        verdict: 'Very', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Miranda is very pretty, chic, and well oriented.`,
    good: `You're obviously super smart and well-oriented, and you manage to make yourself look fashionable and classy somehow too`,
    notGood: `The only thing I'd change is the pigeon photo`,
    verdict: `Overall the profile definitely displays an attractive Miranda. Just change out the pigeon photo and you'll be set`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...carrieReviewerReviewHinge },
  reviewerProfile: { ...carrieReviewerProfile },
  bioItems: { ...mirandaBio },
  mediaItems: [ ...mirandaMediaArray ],
}

export const charlotteProfileReviewBumble = {
  _id: 'charlotteProfileReviewBumbleId',
  userId: 'mirandaUserId',
  userEmail: 'miranda@email.com',
  datingProfileId: 'mirandaDatingProfileBumbleId',
  reviewerProfileId: 'charlotteReviewerProfileId',
  reviewerEmail: 'charlotte@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: mirandaMediaArray[2]._id,
      mediaItemURL: mirandaMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[2].type,
      caption: mirandaMediaArray[2].captions[1],
      subcaption: mirandaMediaArray[2].subcaptions[1],
    },
    {
      mediaItemId: mirandaMediaArray[8]._id,
      mediaItemURL: mirandaMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[8].type,
      caption: mirandaMediaArray[8].captions[1],
      subcaption: mirandaMediaArray[8].subcaptions[1],
    },
    {
      mediaItemId: mirandaMediaArray[6]._id,
      mediaItemURL: mirandaMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[6].type,
      caption: mirandaMediaArray[6].captions[0],
      subcaption: mirandaMediaArray[6].subcaptions[2],
    },
    {
      mediaItemId: mirandaMediaArray[7]._id,
      mediaItemURL: mirandaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[7].type,
      caption: mirandaMediaArray[7].captions[0],
      subcaption: mirandaMediaArray[7].subcaptions[2],
    },
    {
      mediaItemId: mirandaMediaArray[13]._id,
      mediaItemURL: mirandaMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[13].type,
      caption: mirandaMediaArray[13].captions[0],
      subcaption: mirandaMediaArray[13].subcaptions[0],
    },
    {
      mediaItemId: mirandaMediaArray[12]._id,
      mediaItemURL: mirandaMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[12].type,
      caption: mirandaMediaArray[12].captions[1],
      subcaption: mirandaMediaArray[12].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great here! Love the dress, the earrings, and the candlelight! Great start!`,
      verdict: 'Very',
    },
    {
      feedback: `Another fabulous photo of you! You look fit be Napoleon's next wife`,
      verdict: 'Yes',
    },
    {
      feedback: `Love it! After the two fancier photos, you cut the tension with something more casual and fun. Love the expression`,
      verdict: 'Yes',
    },
    {
      feedback: `OK, I find it funny, but I'm not sure a guy wants to see the Miranda who yells at pigeons until at least the third date`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Hot by the transitive property for sure! Gotta show off the friends`,
      verdict: 'Yes',
    },
    {
      feedback: `Great photo! If you got it flaunt it!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: mirandaBio._id,
    vitalInfo: { ...mirandaBio.vitalInfo },
    prompts: [
      { ...mirandaBio.prompts[0] },
      { ...mirandaBio.prompts[1] },
      { ...mirandaBio.prompts[2] }
    ],
    aboutMe: mirandaBio.aboutMe[0],
    hobbies: [mirandaBio.hobbies[0], mirandaBio.hobbies[1], mirandaBio.hobbies[2], mirandaBio.hobbies[3], mirandaBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Beautiful and successful — Sugar momma alert!`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: 'Fun, light, and sporty — definitely attractive things to be (and accurate descriptors)',
      verdict: 'Yes', 
    },
    promptsFeedback: [
      {
        feedback: `This is good — let them know you aren't impressed by money... They gotta learn you're a badass at somepoint`,
        verdict: 'Yes', 
      },
      {
        feedback: `Shows you as a specific brand of yuppy elite... that you definitely are`,
        verdict: 'Yes', 
      },
      {
        feedback: `This is funny! "Only if the carpet matches the drapes" is the odds-on favorite for likeliest response`,
        verdict: 'Very', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Miranda is very pretty, chic, and well oriented.`,
    good: `You're obviously super smart and well-oriented, and you manage to make yourself look fashionable and classy somehow too`,
    notGood: `The only thing I'd change is the pigeon photo`,
    verdict: `Overall the profile definitely displays an attractive Miranda. Just change out the pigeon photo and you'll be set`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...charlotteReviewerReviewBumble },
  reviewerProfile: { ...charlotteReviewerProfile },
  bioItems: { ...mirandaBio },
  mediaItems: [ ...mirandaMediaArray ],
}

export const samanthaProfileReviewTinder = {
  _id: 'samanthaProfileReviewTinderId',
  userId: 'mirandaUserId',
  userEmail: 'miranda@email.com',
  datingProfileId: 'mirandaDatingProfileTinderId',
  reviewerProfileId: 'samanthaReviewerProfileId',
  reviewerEmail: 'samantha@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: mirandaMediaArray[2]._id,
      mediaItemURL: mirandaMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[2].type,
      caption: mirandaMediaArray[2].captions[1],
      subcaption: mirandaMediaArray[2].subcaptions[1],
    },
    {
      mediaItemId: mirandaMediaArray[8]._id,
      mediaItemURL: mirandaMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[8].type,
      caption: mirandaMediaArray[8].captions[1],
      subcaption: mirandaMediaArray[8].subcaptions[1],
    },
    {
      mediaItemId: mirandaMediaArray[6]._id,
      mediaItemURL: mirandaMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[6].type,
      caption: mirandaMediaArray[6].captions[0],
      subcaption: mirandaMediaArray[6].subcaptions[2],
    },
    {
      mediaItemId: mirandaMediaArray[7]._id,
      mediaItemURL: mirandaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[7].type,
      caption: mirandaMediaArray[7].captions[0],
      subcaption: mirandaMediaArray[7].subcaptions[2],
    },
    {
      mediaItemId: mirandaMediaArray[13]._id,
      mediaItemURL: mirandaMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[13].type,
      caption: mirandaMediaArray[13].captions[0],
      subcaption: mirandaMediaArray[13].subcaptions[0],
    },
    {
      mediaItemId: mirandaMediaArray[12]._id,
      mediaItemURL: mirandaMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[12].type,
      caption: mirandaMediaArray[12].captions[1],
      subcaption: mirandaMediaArray[12].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great here! Love the dress, the earrings, and the candlelight! Great start!`,
      verdict: 'Very',
    },
    {
      feedback: `Another fabulous photo of you! You look fit be Napoleon's next wife`,
      verdict: 'Yes',
    },
    {
      feedback: `Love it! After the two fancier photos, you cut the tension with something more casual and fun. Love the expression`,
      verdict: 'Yes',
    },
    {
      feedback: `OK, I find it funny, but I'm not sure a guy wants to see the Miranda who yells at pigeons until at least the third date`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Hot by the transitive property for sure! Gotta show off the friends`,
      verdict: 'Yes',
    },
    {
      feedback: `Great photo! If you got it flaunt it!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: mirandaBio._id,
    vitalInfo: { ...mirandaBio.vitalInfo },
    prompts: [
      { ...mirandaBio.prompts[0] },
      { ...mirandaBio.prompts[1] },
      { ...mirandaBio.prompts[2] }
    ],
    aboutMe: mirandaBio.aboutMe[0],
    hobbies: [mirandaBio.hobbies[0], mirandaBio.hobbies[1], mirandaBio.hobbies[2], mirandaBio.hobbies[3], mirandaBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Beautiful and successful — Sugar momma alert!`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: 'Fun, light, and sporty — definitely attractive things to be (and accurate descriptors)',
      verdict: 'Yes', 
    },
    promptsFeedback: [
      {
        feedback: `This is good — let them know you aren't impressed by money... They gotta learn you're a badass at somepoint`,
        verdict: 'Yes', 
      },
      {
        feedback: `Shows you as a specific brand of yuppy elite... that you definitely are`,
        verdict: 'Yes', 
      },
      {
        feedback: `This is funny! "Only if the carpet matches the drapes" is the odds-on favorite for likeliest response`,
        verdict: 'Very', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Miranda is very pretty, chic, and well oriented.`,
    good: `You're obviously super smart and well-oriented, and you manage to make yourself look fashionable and classy somehow too`,
    notGood: `The only thing I'd change is the pigeon photo`,
    verdict: `Overall the profile definitely displays an attractive Miranda. Just change out the pigeon photo and you'll be set`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...samanthaReviewerReviewTinder },
  reviewerProfile: { ...samanthaReviewerProfile },
  bioItems: { ...mirandaBio },
  mediaItems: [ ...mirandaMediaArray ],
}